import { authenticatedPatch } from '../../../../../../api/request';

export default async function updateMotives(idDoctorUser, motiveBody, setErrorMessage) {
    const onFail = () => setErrorMessage('Ocurrió un error guardando la actualización del motivo.');
    const url = `/doctor-profile-management/motives/${idDoctorUser}`;
    return await authenticatedPatch(url, onFail, motiveBody);
}
